import React from 'react';
import clientInformation, { getClientItem } from '../login/ClientInfo';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCopy } from '@fortawesome/free-solid-svg-icons'
import { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import Alerts from '../helpers/Alerts';
import Loading from '../helpers/Loader';
import { IsValidToken, CheckCustomerData } from "../../services/AuthenticationService";
import { useParams } from 'react-router-dom';
import { onlyNumbers, BonusString } from '../helpers/common';
import { EWalletDeposit } from "../../services/DepositService";
import Bonus from '../Bonus';
import { isMobile } from 'react-device-detect';
import { MissingAccountInfo } from "../deposit/MissingAccountInfo.jsx";
import iframeResizer from 'iframe-resizer';
import swal from 'sweetalert2';

export const PaycashMethod = () => {
    const clientInfo = clientInformation();
    let MAXLIMIT = process.env.REACT_APP_MaxLimit;
    let INSTANCEID = clientInfo.InstanceID;
    let url = /^(http[s]?:\/\/){0,1}(www\.){0,1}[a-zA-Z0-9\.\-]+\.[a-zA-Z]{2,5}[\.]{0,1}/;
    const { id } = useParams();
    const [arrayRegularDeposits, setRegularDeposits] = useState(JSON.parse(getClientItem('ArrayRegularMethods')).filter(function (element) { return element.DepositID == id; })[0]);
    const navigate = useNavigate();
    const [isProcessing, setIsProcessing] = useState(false);
    const [showiFrame, setshowiFrame] = useState(false);
    const [showFrameTitle, setShowFrameTitle] = useState(true);
    const [showForm, setshowForm] = useState(false);
    const [showConfirm, setShowConfirm] = useState(false);
    const [showPopular, setShowPopular] = useState(false);
    const [showBHD, setShowBHD] = useState(false);
    const [showBanks, setShowBanks] = useState(true);
    const [, updateState] = React.useState();
    const forceUpdate = React.useCallback(() => updateState({}), []);
    const [arrayEwallet, setArrayEwallet] = useState([]);
    const [isValidate, setIsValidate] = useState(true);
    const [isSecureIdVisible, setIsSecureIdVisible] = useState(false);
    const [isAccountVisible, setIsAccountVisible] = useState(false);
    const [height, setHeight] = useState('500px');
    const iframeRef = React.useRef(null);
    const lastHeightRef = React.useRef(0);
    const debounceTimeout = React.useRef(null);
    const [shouldScroll, setShouldScroll] = useState(false);
    const fixedAmount = Number(getClientItem('FixedAmount')) || 0;
    const [amount, setAmount] = useState(fixedAmount > 0 ? fixedAmount : '');
    const [reference, setReference] = useState('');
    const [showDeposits, setShowDeposits] = useState(false);

    useEffect(() => {
        IsValidToken(getClientItem('Token')).then(function (response) {
            validateFields();
            doCheckCustomerData();

        })
            .catch(function (error) {
                navigate('/expired/');
            })
        if (arrayRegularDeposits == undefined) {
            navigate('/deposits/');
        }

        // Funci�n para copiar el n�mero de referencia
        window.copyReferenceNumber = function (refNum) {
            navigator.clipboard.writeText(refNum).then(() => {
                const feedbackDiv = document.getElementById('copyFeedback');
                if (feedbackDiv) {
                    feedbackDiv.style.display = 'inline';
                    feedbackDiv.style.color = 'green';
                    feedbackDiv.textContent = 'Copied!';

                    setTimeout(() => {
                        feedbackDiv.style.display = 'none';
                    }, 2000);
                }
            });
        }
        const handleMessage = (event) => {
            // Optional: Validate origin
            // if (event.origin !== 'https://trusted-site.com') return;

            const data = event.data;
            if (data && data['full-content-height']) {
                setShowFrameTitle(false);
                const newHeight = parseInt(data['full-content-height'], 10);

                // Clamp to reasonable range (e.g., 300px to 900px)
                if (newHeight < 300 || newHeight > 900) return;

                // Debounce to avoid rapid resizing
                if (debounceTimeout.current) {
                    clearTimeout(debounceTimeout.current);
                }

                debounceTimeout.current = setTimeout(() => {
                    // Only update if height actually changed
                    if (newHeight !== lastHeightRef.current) {
                        lastHeightRef.current = newHeight;
                        setHeight(`${newHeight}px`);
                    }
                }, 300);
            }
        };

        window.addEventListener('message', handleMessage);
        return () => {
            window.removeEventListener('message', handleMessage);
            if (debounceTimeout.current) {
                clearTimeout(debounceTimeout.current);
            }
        };



    }, [])


    function handleResponseFromComponent(response) {
        setIsValidate(response);
    }

    async function validateFields() {
        switch (arrayRegularDeposits.ImageName.toLowerCase()) {
            case "paysafecard":
            case "bitcoin":
            case "marketusa":
            case "wipay":
            case "changelly":
            case "wallet88":
            case "quickbuy":
            case "flashteller":
            case "triplewallet":
            case "majestic":
            case "applepay":
            case "googlepay":
            case "cashapp":
            case "paypal":
            case "venmo":
            case "zelle":
            case "moonpay":
            case "alphapaysonramp":
            case "tylt":
            case "paycash":
                {
                    setIsSecureIdVisible(false);
                    setIsAccountVisible(false);
                    setHeight('700px');
                }
                break;
            case "wallet88emt":
                {
                    setIsSecureIdVisible(false);
                    setIsAccountVisible(false);
                    setHeight('700px');
                }
                break;
            case "quickervoucherv2":
            case "kribatta":

                {
                    setIsSecureIdVisible(false);
                    setIsAccountVisible(false);
                    setHeight('900px');
                }
                break;
            case "fastgateway":
                {
                    setIsSecureIdVisible(false);
                    setIsAccountVisible(false);
                    setHeight('550px');
                    setShouldScroll(true);
                }
                break;
            default:
                {
                    setIsSecureIdVisible(false);
                    setIsAccountVisible(true);
                }
                break;
        }
    }

    async function doCheckCustomerData() {
        await CheckCustomerData(getClientItem('Token'), arrayRegularDeposits.DepositID).then(async function (response) {
            if (!response.Authentication.AllComplete) {
                setIsValidate(true);
            }
            else {
                setIsValidate(false);
            }
        })
    };

    if (isValidate) {
        return <MissingAccountInfo Processor={arrayRegularDeposits.DepositID} isValidate={handleResponseFromComponent.bind(isValidate)} />;
    }

    async function doEWalletDeposit(Amount, Account, SecureID) {
        
        var Data =
        {
            "Token": getClientItem('Token'),
            "eWalletAccount": Account,
            "eWalletPassword": SecureID,
            "ProcessorName": arrayRegularDeposits.DepositName,
            "InstanceID": INSTANCEID,
            "Amount": Amount,
            "CurrencyCode": clientInfo.CurrencyCode,
            "returnURL": "",
            "statusURL": "",
            "TransactionID": "-1",
            "IPv4Address": clientInfo.IPAddress,
            "BonusList": BonusString(JSON.parse(getClientItem('ArrayBonus')))
        };
        
        await EWalletDeposit(Data).then(function (response) {

            setArrayEwallet(response.Authentication);

            if (response.Authentication.ErrorCode != undefined && response.Authentication.ErrorCode != null) {

                if (isMobile) {
                    Alerts.ShowAlertFullScreen('Error con el Deposito', response.Authentication.ErrorDescription, 'error');
                }
                else {
                    Alerts.ShowAlert('Error con el Deposito', response.Authentication.ErrorDescription, 'error');
                }

            }
            else {
                var message = response.Authentication.HtmlResponse;

                try {
                    var payload = {
                        TransactionID: response.Authentication.TransactionID,
                        Amount: amount,
                        Status: response.Authentication.status,
                        ProcessorName: response.Authentication.ProcesorName
                    }

                    window.parent.postMessage(
                        { 'transactionInfo': payload },
                        '*'
                    );
                }
                catch (error) { }

                if (response.Authentication.status == "PENDING") {

                    setReference(response.Authentication.Descriptor);
                    setshowForm(false);
                    setShowConfirm(true);
                    
                  
                }
                else if (response.Authentication.status == "REJECTED") {
                    if (isMobile) {
                        Alerts.ShowAlertFullScreen('Deposito Rechazado', message, 'info');
                    }
                    else {
                        Alerts.ShowAlert('Deposito Rechazado', message, 'info');
                    }

                }
                else {
                    if (isMobile) {
                        Alerts.ShowAlertFullScreen('Deposito Completado', message, 'info');
                    }
                    else {
                        Alerts.ShowAlert('Deposito Completado', message, 'info');
                    }
                }

            }

        })
            .catch(function (error) {
                if (isMobile) {
                    Alerts.ShowAlertFullScreen('Error', 'Error making deposit ' + error, 'error');
                }
                else {
                    Alerts.ShowAlert('Error', 'Error making deposit ' + error, 'error');
                }

            })


    }

    const handleSubmit = async (event) => {
        event.preventDefault();

        if (showConfirm) {
            setShowDeposits(true);
           var message = `
                    <p>Tu pago est\u00E1 siendo validado por el banco.<br/>
                    Puede tomar <strong>hasta 10 minutos</strong> en acreditarse a tu cuenta.</p>
                    <div style='display: flex; align-items: center; justify-content: center; gap: 10px; margin: 15px 0; border: 1px solid #ddd; border-radius: 8px; padding: 12px;'>
                        <span style='font-size: 13px; font-weight: bold; color: #888; letter-spacing: 1px;'>REFERENCIA</span>
                        <span id='refNumber' style='font-size: 20px; font-weight: bold; color: #333;'>
                            ${reference}
                        </span>
                        <button onclick="copyReferenceNumber('${reference}')"
                            style='background: none; border: none; cursor: pointer; font-size: 18px; padding: 5px; color: #007bff;' 
                            title='Copy to clipboard'>
                            <i class='fas fa-copy'></i>
                        </button>
                        <span id='copyFeedback' style='display: none; font-size: 14px; margin-left: 10px;'></span>
                    </div>
                `;
            if (isMobile) {
                Alerts.ShowAlertFullScreen('Pago en proceso', message, 'info');
            }
            else {
                Alerts.ShowAlert('Pago en proceso', message, 'info');
            }
            return;
        }

        if (!isProcessing) {
            var data = new FormData(event.target);
            let { amount, accountoremail, secureid } = Object.fromEntries(data.entries());
            if (amount != '') {
                setIsProcessing(true);
                await doEWalletDeposit(amount, accountoremail, secureid);
                setIsProcessing(false);
            }
            else {
                Alerts.ShowAlert('Advertencia', 'Monto requerido', 'warning');
            }
        }
    }

    const handleIframeLoad = () => {
        setShowFrameTitle(false);
    }

    return (
        <div className="componentload">
            <form onSubmit={handleSubmit}>
                <div className="row m-4">
                    <span className="icon-single-left txt-primary">
                        <img style={{ width: "100px", height: "100px", }} src={"/svg/" + arrayRegularDeposits.ImageName + ".svg"} /> <span> Dep&oacute;sito usando {id} </span>
                    </span>
                </div>
                {
                    id.toLowerCase() == "ph-paypal" && <div className="row m-1">
                        <div className="alert alert-primary text-center" role="alert">
                            To use PayPal as a deposit method, customers must first ensure that funds are available in their PayPal account. <b>Add money to your PayPal balance</b> before attempting to make a deposit.
                        </div>
                    </div>
                }
                {
                    id.toLowerCase() == "ph-applepay" && <div className="row m-1">
                        <div className="alert alert-primary text-center" role="alert">
                            To successfully use Google Pay or Apple Pay for deposits, the <b>billing address on your Apple/Google Pay account must match the address listed </b> on your customer account.
                            Please verify this information before proceeding with a deposit.
                        </div>
                    </div>
                }
                {
                    id.toLowerCase() == "ph-moonpay" && <div className="row m-1">
                        <div className="alert alert-primary text-left" role="alert">
                            Before using MoonPay for deposits, customers are required to complete a one-time KYC (Know Your Customer) verification process. This process includes:
                           <ul class="m-1">
                                <li>Uploading a valid picture ID</li>
                                <li>Completing a biometric scan</li>
                                <li>Providing your Social Security Number (SSN) For US customers only</li>
                            </ul>
                        </div>
                    </div>
                }
                {showiFrame && <div>
                    {showFrameTitle && <h5 id="frameTitle">Please wait, your form will load in a few seconds...</h5>}
                    { /*onLoad={handleIframeLoad}*/}
                    <iframe
                        ref={iframeRef}
                        style={shouldScroll ? { overflow: 'scroll' } : undefined}
                        onLoad={handleIframeLoad}
                        src={arrayEwallet.Descriptor}
                        height={height}
                        width="100%"
                        {...(shouldScroll ? { scrolling: 'yes' } : {})}
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture full"
                    ></iframe>
                </div>}
                {showBanks &&
                    <div className="row">
                        <div className="col-xxl-4 col-md-4 col-sm-6 col-xs-6">
                            <div className="box-deposit mb-4" style={{ cursor: 'pointer' }}
                            onClick={() => {
                                setshowForm(true);
                                    setShowPopular(true);
                                    setShowBanks(false);
                                }}>
                                <div className="row">
                                    <div className="col-md-3 col-sm-12">
                                        <div className="image-wrapper">
                                            <span className="icon-single">
                                            <img alt="" src="/svg/bankPaycash.svg" />
                                            </span>
                                        </div>
                                    </div>
                                    <div className="col-md-8 col-sm-12 text-center limit-text">
                                        <span>Banco Popular</span>
                                    </div>
                                    <div className="col-md-3 limit-text d-none d-md-block"></div>
                                </div>
                            </div>
                        </div>

                        <div className="col-xxl-4 col-md-4 col-sm-6 col-xs-6">
                            <div className="box-deposit mb-4" style={{ cursor: 'pointer' }}
                            onClick={() => {
                                setshowForm(true);
                                    setShowBHD(true);
                                    setShowBanks(false);
                                }}>
                                <div className="row">
                                    <div className="col-md-3 col-sm-12">
                                        <div className="image-wrapper">
                                            <span className="icon-single">
                                            <img alt="" src="/svg/bankPaycash.svg" />
                                            </span>
                                        </div>
                                    </div>
                                    <div className="col-md-8 col-sm-12 text-center limit-text">
                                    <span>BHD Le&oacute;n</span>
                                    </div>
                                    <div className="col-md-3 limit-text d-none d-md-block"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                }
                {showForm && <div >
                    <div className="row">
                        <div className="col-md-12 col-sm-12">
                            <div className="row">
                                {isSecureIdVisible && <div className="col-md-12 clear row-12" >
                                    <div className="col-md-12 col-sm-12 col-xs-12">
                                        <label for="secureid" className="col-md-offset-3 col-md-2  col-sm-offset-3 col-sm-2 col-xs-12">SecureID:</label>
                                        <div className="col-md-7 col-sm-7 col-xs-12">
                                            <input type="password" className="form-control" name="secureid"
                                                aria-label="secure id" placeholder="SecureID" required />
                                        </div>
                                    </div>
                                </div>}
                                {isAccountVisible && <div className="col-md-12 clear row-12 mb-4">
                                    <div className="col-md-12 col-sm-12 col-xs-12">
                                        <label for="secureid" className="col-md-offset-3 col-md-2  col-sm-offset-3 col-sm-2 col-xs-12">Account:</label>
                                        <div className="col-md-7 col-sm-7 col-xs-12">
                                            <input type="text" className="form-control" name="accountoremail"
                                                aria-label="account or email" placeholder="Account" required />
                                        </div>
                                    </div>
                                </div>}
                                <div className="col-md-7 col-sm-7 col-xs-12">
                                    <div className="col-md-12 m3 ">

                                        <div className="input-group mb-3  ">
                                            <div className="input-group mb-3">
                                                <div className="input-group-prepend">
                                                    <span className="input-group-currency-cards d-none d-md-block" id="lblCurrency">
                                                        <select className="form-control selectcurrency" readOnly name="CurrencyCode" required value={clientInfo.CurrencyCode == 'mBTC' ? 'USD' : clientInfo.CurrencyCode}>
                                                            <option value="" className="">Currency</option>
                                                            <option selected value="USD">USD</option>
                                                            <option value="EUR">EUR</option>
                                                            <option value="GBP">GBP</option>
                                                            <option value="CAD">CAD</option>
                                                            <option value="DOP">DOP</option>
                                                        </select>
                                                    </span>
                                                </div>
                                                <input type="number" onKeyPress={(event) => onlyNumbers(event)} aria-label="Amount (to the nearest dollar)" className="form-control" id="amount" aria-describedby="lblCurrency" placeholder="Digite el monto" max={arrayRegularDeposits?.MaxDeposit === 0 ? MAXLIMIT : arrayRegularDeposits?.MaxDeposit} min={arrayRegularDeposits?.MinDeposit === 0 ? 1 : arrayRegularDeposits?.MinDeposit} name="amount" required="" value={amount} onChange={(e) => setAmount(e.target.value)} readOnly={fixedAmount > 0}/>
                                            </div>
                                        </div>
                                        <div className="d-flex flex-row ml-2 limit-text-center mb-4 ">
                                            L&iacute;mites: M&iacute;nimo {arrayRegularDeposits.MinDeposit == 0 ? 1 : arrayRegularDeposits.MinDeposit} {clientInfo.CurrencyCode} M&aacute;ximo {arrayRegularDeposits.MaxDeposit == 0 ? 'Sin Limite' : arrayRegularDeposits.MaxDeposit + ' ' + clientInfo.CurrencyCode}
                                        </div>
                                    </div>

                                </div>
                                {showPopular && <div className="row">
                                    <div className="col-md-2">&nbsp;</div>
                                    <div className="col-md-12 col-sm-12 col-xs-12 mb-3">
                                        <div className="input-group">
                                            <div className="alert alert-primary" role="alert" style={{ width: "100%" }}>
                                                <p><strong>C&Oacute;MO REALIZAR TU PAGO</strong></p>
                                                <ol>
                                                    <li>Accede a Internet Banking de <strong>Banco Popular</strong> e ingresa tus datos de acceso.</li>
                                                    <li>Dentro de <strong>"Pagos"</strong>, selecciona <strong>"Pagar servicios y facturas"</strong>.</li>
                                                    <li>Si es tu primera vez, agrega <strong>"PayCash &mdash; Monto Cerrado"</strong> como nuevo beneficiario.</li>
                                                    <li>Digita el n&uacute;mero de referencia de 16 d&iacute;gitos que aparecer&aacute; en el siguiente paso.</li>
                                                    <li>Confirma la operaci&oacute;n utilizando tu <strong>token de seguridad.</strong></li>
                                                </ol>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-2">&nbsp;</div>
                                </div>}
                                {showBHD && <div className="row">
                                    <div className="col-md-2">&nbsp;</div>
                                    <div className="col-md-12 col-sm-12 col-xs-12 mb-3">
                                        <div className="input-group">
                                            <div className="alert alert-primary" role="alert" style={{ width: "100%" }}>
                                                <p><strong>C&Oacute;MO REALIZAR TU PAGO</strong></p>
                                                <ol>
                                                    <li>Accede a Internet Banking a trav&eacute;s de tu banco e ingresa tus datos de acceso.</li>
                                                    <li>Dentro de <strong>"Pagos y Transferencias"</strong>, selecciona <strong>"Pagos de servicios e impuestos"</strong>.</li>
                                                    <li>Selecciona el proveedor de servicio <strong>"PayCash"</strong> y elige <strong>"PayCash Pago Referenciado"</strong>.</li>
                                                    <li>Digita el n&uacute;mero de referencia de 16 d&iacute;gitos que aparecer&aacute; en el siguiente paso.</li>
                                                    <li>Coloca los 4 d&iacute;gitos de tu tarjeta de claves y procesa el pago.</li>
                                                </ol>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-2">&nbsp;</div>
                                </div>}
                                <Bonus ProcessorName={id} />
                            </div>
                        </div>

                    </div>

                </div>}
                {showConfirm && <div>
                    <div className="row">
                        <div className="col-md-12 col-sm-12">
                            <div className="row">
                                <div className="col-md-7 col-sm-7 col-xs-12">
                                    <div className="col-md-12 m3">
                                        <div className="input-group mb-3">
                                            <div className="input-group mb-3">
                                                <span className="input-group-text">Referencia</span>
                                                <input type="text" className="form-control" readOnly
                                                    value={reference} placeholder="Referencia" />
                                                <button type="button"
                                                    className="btn btn-outline-secondary"
                                                    title="Copiar referencia"
                                                    onClick={() => {
                                                        navigator.clipboard.writeText(reference);
                                                        document.getElementById('copyFeedbackInput').style.display = 'inline';
                                                        setTimeout(() => {
                                                            document.getElementById('copyFeedbackInput').style.display = 'none';
                                                        }, 2000);
                                                    }}>
                                                    <i className="fas fa-copy"></i>
                                                </button>
                                                <span id="copyFeedbackInput" style={{ display: 'none', fontSize: '13px', marginLeft: '8px', alignSelf: 'center', color: 'green' }}>
                                                    Copiado
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-2">&nbsp;</div>
                                    {showPopular && <div className="col-md-12 col-sm-12 col-xs-12 mb-3">
                                        <div className="input-group">
                                            <div className="alert alert-primary" role="alert" style={{ width: "100%" }}>
                                                <style>{`
                                                    .accordion-collapse {
                                                        transition: height 0.35s ease !important;
                                                    }
                                                    .accordion-button {
                                                        transition: all 0.2s ease !important;
                                                    }
                                                    .accordion-button::after {
                                                        transition: transform 0.35s ease !important;
                                                    }
                                                `}</style>

                                                <div className="accordion" id="accordionPaycash">

                                                    {/* Agregar Beneficiario */}
                                                    <div className="accordion-item mb-3">
                                                        <h2 className="accordion-header" id="headingBeneficiario">
                                                            <button className="accordion-button " type="button"
                                                                data-bs-toggle="collapse" data-bs-target="#collapseBeneficiario"
                                                                aria-expanded="true" aria-controls="collapseBeneficiario">
                                                                <strong>Agregar Beneficiario</strong>&nbsp;<span style={{ fontSize: '13px' }}>(Solo la primera vez)</span>
                                                            </button>
                                                        </h2>
                                                        <div id="collapseBeneficiario" className="accordion-collapse collapse show"
                                                            aria-labelledby="headingBeneficiario" data-bs-parent="#accordionPaycash">
                                                            <div className="accordion-body">
                                                                <ol>
                                                                    <li>Ingrese a la banca electr&oacute;nica de <strong>Banco Popular.</strong></li>
                                                                    <li>Dir&iacute;jase a <strong>Beneficiarios &mdash; Servicios y facturas &mdash; Agregar servicio o factura.</strong></li>
                                                                    <li>Seleccione servicios financieros y elija <strong>Paycash &mdash; Monto Cerrado.</strong></li>
                                                                    <li>Complete la informaci&oacute;n solicitada y confirme la operaci&oacute;n utilizando su token.</li>
                                                                    <li>Verifique el comprobante de registro del beneficiario.</li>
                                                                </ol>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    {/* Realizar Pago Paycash */}
                                                    <div className="accordion-item">
                                                        <h2 className="accordion-header" id="headingPago">
                                                            <button className="accordion-button collapsed" type="button"
                                                                data-bs-toggle="collapse" data-bs-target="#collapsePago"
                                                                aria-expanded="false" aria-controls="collapsePago">
                                                                <strong>Realizar Pago Paycash</strong>
                                                            </button>
                                                        </h2>
                                                        <div id="collapsePago" className="accordion-collapse collapse"
                                                            aria-labelledby="headingPago" data-bs-parent="#accordionPaycash">
                                                            <div className="accordion-body">
                                                                <ol>
                                                                    <li>Ingrese a la banca electr&oacute;nica de <strong>Banco Popular.</strong></li>
                                                                    <li>Dir&iacute;jase a <strong>Pagos &mdash; Pagar servicios y facturas.</strong></li>
                                                                    <li>Seleccione <strong>Paycash Monto Cerrado</strong> de su lista de beneficiarios.</li>
                                                                    <li>Ingrese el n&uacute;mero de referencia de 16 d&iacute;gitos que aparece arriba.</li>
                                                                    <li>Complete el pago utilizando su token de seguridad.</li>
                                                                </ol>
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>}
                                    {showBHD && <div className="col-md-12 col-sm-12 col-xs-12 mb-3">
                                        <div className="input-group">
                                            <div className="alert alert-primary" role="alert" style={{ width: "100%" }}>
                                                <p><strong>C&Oacute;MO REALIZAR TU PAGO</strong></p>
                                                <ol>
                                                    <li>Accede a Internet Banking a trav&eacute;s de tu banco e ingresa tus datos de acceso.</li>
                                                    <li>Dentro de <strong>"Pagos y Transferencias"</strong>, selecciona <strong>"Pagos de servicios e impuestos"</strong>.</li>
                                                    <li>Selecciona <strong>"Servicio Nuevo"</strong> si no lo tienes inscrito.</li>
                                                    <li>Selecciona el proveedor de servicio <strong>"PayCash"</strong>.</li>
                                                    <li>Selecciona <strong>"PayCash Pago Referenciado"</strong>.</li>
                                                    <li>Selecciona el producto con el que deseas pagar.</li>
                                                    <li>Digita el n&uacute;mero de referencia de 16 d&iacute;gitos y presiona <strong>"Consultar monto a pagar"</strong>.</li>
                                                    <li>Coloca los 4 d&iacute;gitos de tu tarjeta de claves y procesa el pago.</li>
                                                </ol>
                                            </div>
                                        </div>
                                    </div>}
                                    <div className="col-md-2">&nbsp;</div>
                                </div>
                                <Bonus ProcessorName={id} />
                            </div>
                        </div>
                    </div>
                </div>}
                <div className="row">
                    <div className="col-md-12 col-sm-12 col-xs-12 " >

                    </div>
                    <div className="col-md-12 mb-3-small mt-4 actionbuttons">
                        <button type="button" className="btn btn-secondary btn-gray btn-back-order mb-4"
                            onClick={() => {

                                if (showDeposits) {
                                    navigate('/deposits/');
                                }

                                if (showForm) {
                                    setshowForm(false);
                                    setShowBHD(false);
                                    setShowPopular(false);
                                    setShowBanks(true);
                                } else if (showConfirm) {
                                    setshowForm(true);
                                    setShowConfirm(false);
                                } else {
                                    navigate('/deposits/');
                                }
                            }}>
                            ATR&Aacute;S
                        </button>
                        {(showForm || showConfirm) &&
                            <button type="submit"
                                className="btn btn-deposit btn-deposit-order mb-4 submit"
                                disabled={isProcessing}>
                            {isProcessing ? "Procesando..." : showConfirm ? "Aceptar - ya realic\u00E9 el pago" : "Continuar"}
                            </button>
                        }
                    </div>
                </div>
            </form >
            <div>
                {isProcessing && <Loading />}
            </div>
        </div>

    );
}